/* tempexp_18086-start */
export enum ReferralFeatures {
    noads = 'Реклама в Почте и Облаке отключится',
    upload = 'Файлы до 100 ГБ сохранятся и отправятся в письмах',
    support = 'Поддержка ответит в течение часа с 9:00 до 21:00',
    family = 'Ещё 3 участника бесплатно оценят возможности подписки',
    themePublic = 'Папки, которыми делитесь, будут с красивым фоном',
    passwordPublic = 'Совместные папки спрячутся под паролем',
}

/* tempexp_18086-end */
